var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgSocialSlack = function SvgSocialSlack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "social-slack_svg__icon"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.373 10.115a1.68 1.68 0 1 1-3.36 0c0-.93.75-1.682 1.68-1.682h1.68v1.682Zm.84 0a1.68 1.68 0 1 1 3.36 0v4.204a1.68 1.68 0 1 1-3.36 0v-4.204ZM5.893 3.363a1.68 1.68 0 0 1-1.68-1.681 1.68 1.68 0 1 1 3.36 0v1.681h-1.68Zm0 .854c.93 0 1.68.751 1.68 1.681a1.68 1.68 0 0 1-1.68 1.682H1.68A1.68 1.68 0 0 1 0 5.898c0-.93.751-1.681 1.68-1.681h4.213ZM12.627 5.898a1.68 1.68 0 1 1 3.36 0 1.68 1.68 0 0 1-1.68 1.682h-1.68V5.898Zm-.84 0a1.68 1.68 0 1 1-3.36 0V1.682a1.68 1.68 0 1 1 3.36 0v4.216ZM10.107 12.637c.929 0 1.68.752 1.68 1.681a1.68 1.68 0 1 1-3.36 0v-1.681h1.68Zm0-.84a1.68 1.68 0 0 1-1.68-1.682c0-.93.75-1.682 1.68-1.682h4.213c.929 0 1.68.752 1.68 1.682a1.68 1.68 0 0 1-1.68 1.681h-4.213Z",
    fill: "currentColor"
  })));
};

export default SvgSocialSlack;